module.exports = __webpack_public_path__ + "img/bird_white.ba80a78f.svg";